module.exports = __webpack_public_path__ + "static/media/facebook.4fbb3309.svg";